// Custom icons: some of the icons' design is changed by Andreas. We should add
// those kind of icons to here
import CheckCustomIcon from "@/assets/svg/custom/check.svg";
import IBGCustomIcon from "@/assets/svg/custom/ibg.svg?component";
import ReorderCustomIcon from "@/assets/svg/reorder-icon.svg?component";
// PLACEHOLDER_END_CUSTOM

import { defineAsyncComponent } from "vue";

export const SVGIcons = {
  // custom
  "custom-check": CheckCustomIcon,
  "custom-ibg": IBGCustomIcon,
  "custom-reorder": ReorderCustomIcon,

  // fal
  "fal-alarm-clock": defineAsyncComponent(
    () => import("@/assets/svg/light/alarm-clock.svg?component"),
  ),
  "fal-archive": defineAsyncComponent(
    () => import("@/assets/svg/light/archive.svg?component"),
  ),
  "fal-arrow-left": defineAsyncComponent(
    () => import("@/assets/svg/light/arrow-left.svg?component"),
  ),
  "fal-arrow-right": defineAsyncComponent(
    () => import("@/assets/svg/light/arrow-right.svg?component"),
  ),
  "fal-arrow-up-right-from-square": defineAsyncComponent(
    () => import("@/assets/svg/light/arrow-up-right-from-square.svg?component"),
  ),
  "fal-arrow-up": defineAsyncComponent(
    () => import("@/assets/svg/light/arrow-up.svg?component"),
  ),
  "fal-arrows-from-line": defineAsyncComponent(
    () => import("@/assets/svg/light/arrows-from-line.svg?component"),
  ),
  "fal-arrows-up-down-left-right": defineAsyncComponent(
    () => import("@/assets/svg/light/arrows-up-down-left-right.svg?component"),
  ),
  "fal-ban": defineAsyncComponent(
    () => import("@/assets/svg/light/ban.svg?component"),
  ),
  "fal-bars-filter": defineAsyncComponent(
    () => import("@/assets/svg/light/bars-filter.svg?component"),
  ),
  "fal-bars": defineAsyncComponent(
    () => import("@/assets/svg/light/bars.svg?component"),
  ),
  "fal-bell-on": defineAsyncComponent(
    () => import("@/assets/svg/light/bell-on.svg?component"),
  ),
  "fal-bell": defineAsyncComponent(
    () => import("@/assets/svg/light/bell.svg?component"),
  ),
  "fal-books": defineAsyncComponent(
    () => import("@/assets/svg/light/books.svg?component"),
  ),
  "fal-bowl-hot": defineAsyncComponent(
    () => import("@/assets/svg/light/bowl-hot.svg?component"),
  ),
  "fal-building": defineAsyncComponent(
    () => import("@/assets/svg/light/building.svg?component"),
  ),
  "fal-bus": defineAsyncComponent(
    () => import("@/assets/svg/light/bus.svg?component"),
  ),
  "fal-cake-candles": defineAsyncComponent(
    () => import("@/assets/svg/light/cake-candles.svg?component"),
  ),
  "fal-calendar-check": defineAsyncComponent(
    () => import("@/assets/svg/light/calendar-check.svg?component"),
  ),
  "fal-calendar-clock": defineAsyncComponent(
    () => import("@/assets/svg/light/calendar-clock.svg?component"),
  ),
  "fal-calendar-days": defineAsyncComponent(
    () => import("@/assets/svg/light/calendar-days.svg?component"),
  ),
  "fal-calendar-plus": defineAsyncComponent(
    () => import("@/assets/svg/light/calendar-plus.svg?component"),
  ),
  "fal-calendar-star": defineAsyncComponent(
    () => import("@/assets/svg/light/calendar-star.svg?component"),
  ),
  "fal-calendar-xmark": defineAsyncComponent(
    () => import("@/assets/svg/light/calendar-xmark.svg?component"),
  ),
  "fal-calendar": defineAsyncComponent(
    () => import("@/assets/svg/light/calendar.svg?component"),
  ),
  "fal-camera": defineAsyncComponent(
    () => import("@/assets/svg/light/camera.svg?component"),
  ),
  "fal-cards": defineAsyncComponent(
    () => import("@/assets/svg/light/cards.svg?component"),
  ),
  "fal-check-square": defineAsyncComponent(
    () => import("@/assets/svg/light/check-square.svg?component"),
  ),
  "fal-check": defineAsyncComponent(
    () => import("@/assets/svg/light/check.svg?component"),
  ),
  "fal-chevron-down": defineAsyncComponent(
    () => import("@/assets/svg/light/chevron-down.svg?component"),
  ),
  "fal-chevron-left": defineAsyncComponent(
    () => import("@/assets/svg/light/chevron-left.svg?component"),
  ),
  "fal-chevron-right": defineAsyncComponent(
    () => import("@/assets/svg/light/chevron-right.svg?component"),
  ),
  "fal-chevron-up": defineAsyncComponent(
    () => import("@/assets/svg/light/chevron-up.svg?component"),
  ),
  "fal-circle-check-left": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-check-left.svg?component"),
  ),
  "fal-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-check.svg?component"),
  ),
  "fal-circle-dot": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-dot.svg?component"),
  ),
  "fal-circle-exclamation": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-exclamation.svg?component"),
  ),
  "fal-circle-minus": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-minus.svg?component"),
  ),
  "fal-circle-play": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-play.svg?component"),
  ),
  "fal-circle-plus": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-plus.svg?component"),
  ),
  "fal-circle-question": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-question.svg?component"),
  ),
  "fal-circle-stop": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-stop.svg?component"),
  ),
  "fal-circle-user-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-user-circle-check.svg?component"),
  ),
  "fal-circle-x": defineAsyncComponent(
    () => import("@/assets/svg/light/circle-x.svg?component"),
  ),
  "fal-circle": defineAsyncComponent(
    () => import("@/assets/svg/light/circle.svg?component"),
  ),
  "fal-clapperboard": defineAsyncComponent(
    () => import("@/assets/svg/light/clapperboard.svg?component"),
  ),
  "fal-clipboard-check": defineAsyncComponent(
    () => import("@/assets/svg/light/clipboard-check.svg?component"),
  ),
  "fal-clipboard-user": defineAsyncComponent(
    () => import("@/assets/svg/light/clipboard-user.svg?component"),
  ),
  "fal-clipboard": defineAsyncComponent(
    () => import("@/assets/svg/light/clipboard.svg?component"),
  ),
  "fal-clock-rotate-left": defineAsyncComponent(
    () => import("@/assets/svg/light/clock-rotate-left.svg?component"),
  ),
  "fal-clock": defineAsyncComponent(
    () => import("@/assets/svg/light/clock.svg?component"),
  ),
  "fal-copy": defineAsyncComponent(
    () => import("@/assets/svg/light/copy.svg?component"),
  ),
  "fal-crop": defineAsyncComponent(
    () => import("@/assets/svg/light/crop.svg?component"),
  ),
  "fal-delete-left": defineAsyncComponent(
    () => import("@/assets/svg/light/delete-left.svg?component"),
  ),
  "fal-diamond-turn-right": defineAsyncComponent(
    () => import("@/assets/svg/light/diamond-turn-right.svg?component"),
  ),
  "fal-dot": defineAsyncComponent(
    () => import("@/assets/svg/light/dot.svg?component"),
  ),
  "fal-download": defineAsyncComponent(
    () => import("@/assets/svg/light/download.svg?component"),
  ),
  "fal-elipsis-vertical": defineAsyncComponent(
    () => import("@/assets/svg/light/elipsis-vertical.svg?component"),
  ),
  "fal-elipsis": defineAsyncComponent(
    () => import("@/assets/svg/light/elipsis.svg?component"),
  ),
  "fal-envelope-open-text": defineAsyncComponent(
    () => import("@/assets/svg/light/envelope-open-text.svg?component"),
  ),
  "fal-eye-low-vision": defineAsyncComponent(
    () => import("@/assets/svg/light/eye-low-vision.svg?component"),
  ),
  "fal-eye-slash": defineAsyncComponent(
    () => import("@/assets/svg/light/eye-slash.svg?component"),
  ),
  "fal-eye": defineAsyncComponent(
    () => import("@/assets/svg/light/eye.svg?component"),
  ),
  "fal-face-smile-plus": defineAsyncComponent(
    () => import("@/assets/svg/light/face-smile-plus.svg?component"),
  ),
  "fal-face-smile": defineAsyncComponent(
    () => import("@/assets/svg/light/face-smile.svg?component"),
  ),
  "fal-face-viewfinder": defineAsyncComponent(
    () => import("@/assets/svg/light/face-viewfinder.svg?component"),
  ),
  "fal-family-pants": defineAsyncComponent(
    () => import("@/assets/svg/light/family-pants.svg?component"),
  ),
  "fal-file-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/light/file-circle-check.svg?component"),
  ),
  "fal-file-lines": defineAsyncComponent(
    () => import("@/assets/svg/light/file-lines.svg?component"),
  ),
  "fal-file-pdf": defineAsyncComponent(
    () => import("@/assets/svg/light/file-pdf.svg?component"),
  ),
  "fal-file-signature": defineAsyncComponent(
    () => import("@/assets/svg/light/file-signature.svg?component"),
  ),
  "fal-film": defineAsyncComponent(
    () => import("@/assets/svg/light/film.svg?component"),
  ),
  "fal-filters": defineAsyncComponent(
    () => import("@/assets/svg/light/filters.svg?component"),
  ),
  "fal-fingerprint": defineAsyncComponent(
    () => import("@/assets/svg/light/fingerprint.svg?component"),
  ),
  "fal-floppy-disk": defineAsyncComponent(
    () => import("@/assets/svg/light/floppy-disk.svg?component"),
  ),
  "fal-fork-knife": defineAsyncComponent(
    () => import("@/assets/svg/light/fork-knife.svg?component"),
  ),
  "fal-gear": defineAsyncComponent(
    () => import("@/assets/svg/light/gear.svg?component"),
  ),
  "fal-globe": defineAsyncComponent(
    () => import("@/assets/svg/light/globe.svg?component"),
  ),
  "fal-grid-2": defineAsyncComponent(
    () => import("@/assets/svg/light/grid-2.svg?component"),
  ),
  "fal-grid": defineAsyncComponent(
    () => import("@/assets/svg/light/grid.svg?component"),
  ),
  "fal-grip-lines": defineAsyncComponent(
    () => import("@/assets/svg/light/grip-lines.svg?component"),
  ),
  "fal-hand-heart": defineAsyncComponent(
    () => import("@/assets/svg/light/hand-heart.svg?component"),
  ),
  "fal-hands-clapping": defineAsyncComponent(
    () => import("@/assets/svg/light/hands-clapping.svg?component"),
  ),
  "fal-headset": defineAsyncComponent(
    () => import("@/assets/svg/light/headset.svg?component"),
  ),
  "fal-heart": defineAsyncComponent(
    () => import("@/assets/svg/light/heart.svg?component"),
  ),
  "fal-hourglass-end": defineAsyncComponent(
    () => import("@/assets/svg/light/hourglass-end.svg?component"),
  ),
  "fal-hourglass": defineAsyncComponent(
    () => import("@/assets/svg/light/hourglass.svg?component"),
  ),
  "fal-house-user": defineAsyncComponent(
    () => import("@/assets/svg/light/house-user.svg?component"),
  ),
  "fal-house": defineAsyncComponent(
    () => import("@/assets/svg/light/house.svg?component"),
  ),
  "fal-id-card": defineAsyncComponent(
    () => import("@/assets/svg/light/id-card.svg?component"),
  ),
  "fal-image": defineAsyncComponent(
    () => import("@/assets/svg/light/image.svg?component"),
  ),
  "fal-info-circle": defineAsyncComponent(
    () => import("@/assets/svg/light/info-circle.svg?component"),
  ),
  "fal-key": defineAsyncComponent(
    () => import("@/assets/svg/light/key.svg?component"),
  ),
  "fal-layer-group": defineAsyncComponent(
    () => import("@/assets/svg/light/layer-group.svg?component"),
  ),
  "fal-lightbulb": defineAsyncComponent(
    () => import("@/assets/svg/light/lightbulb.svg?component"),
  ),
  "fal-list-checked": defineAsyncComponent(
    () => import("@/assets/svg/light/list-checked.svg?component"),
  ),
  "fal-list": defineAsyncComponent(
    () => import("@/assets/svg/light/list.svg?component"),
  ),
  "fal-loader": defineAsyncComponent(
    () => import("@/assets/svg/light/loader.svg?component"),
  ),
  "fal-location-dot": defineAsyncComponent(
    () => import("@/assets/svg/light/location-dot.svg?component"),
  ),
  "fal-lock-keyhole": defineAsyncComponent(
    () => import("@/assets/svg/light/lock-keyhole.svg?component"),
  ),
  "fal-lock-open": defineAsyncComponent(
    () => import("@/assets/svg/light/lock-open.svg?component"),
  ),
  "fal-lock": defineAsyncComponent(
    () => import("@/assets/svg/light/lock.svg?component"),
  ),
  "fal-magnifying-glass-minus": defineAsyncComponent(
    () => import("@/assets/svg/light/magnifying-glass-minus.svg?component"),
  ),
  "fal-magnifying-glass-plus": defineAsyncComponent(
    () => import("@/assets/svg/light/magnifying-glass-plus.svg?component"),
  ),
  "fal-magnifying-glass": defineAsyncComponent(
    () => import("@/assets/svg/light/magnifying-glass.svg?component"),
  ),
  "fal-medal": defineAsyncComponent(
    () => import("@/assets/svg/light/medal.svg?component"),
  ),
  "fal-megaphone": defineAsyncComponent(
    () => import("@/assets/svg/light/megaphone.svg?component"),
  ),
  "fal-message-dots": defineAsyncComponent(
    () => import("@/assets/svg/light/message-dots.svg?component"),
  ),
  "fal-messages-lines": defineAsyncComponent(
    () => import("@/assets/svg/light/messages-lines.svg?component"),
  ),
  "fal-messages": defineAsyncComponent(
    () => import("@/assets/svg/light/messages.svg?component"),
  ),
  "fal-microphone-slash-check": defineAsyncComponent(
    () => import("@/assets/svg/light/microphone-slash-check.svg?component"),
  ),
  "fal-microphone": defineAsyncComponent(
    () => import("@/assets/svg/light/microphone.svg?component"),
  ),
  "fal-minus": defineAsyncComponent(
    () => import("@/assets/svg/light/minus.svg?component"),
  ),
  "fal-mobile-button": defineAsyncComponent(
    () => import("@/assets/svg/light/mobile-button.svg?component"),
  ),
  "fal-mobile-notch": defineAsyncComponent(
    () => import("@/assets/svg/light/mobile-notch.svg?component"),
  ),
  "fal-money-bill": defineAsyncComponent(
    () => import("@/assets/svg/light/money-bill.svg?component"),
  ),
  "fal-moon-stars": defineAsyncComponent(
    () => import("@/assets/svg/light/moon-stars.svg?component"),
  ),
  "fal-moon": defineAsyncComponent(
    () => import("@/assets/svg/light/moon.svg?component"),
  ),
  "fal-paper-plane": defineAsyncComponent(
    () => import("@/assets/svg/light/paper-plane.svg?component"),
  ),
  "fal-paperclip": defineAsyncComponent(
    () => import("@/assets/svg/light/paperclip.svg?component"),
  ),
  "fal-pause": defineAsyncComponent(
    () => import("@/assets/svg/light/pause.svg?component"),
  ),
  "fal-pen-to-square": defineAsyncComponent(
    () => import("@/assets/svg/light/pen-to-square.svg?component"),
  ),
  "fal-person-running": defineAsyncComponent(
    () => import("@/assets/svg/light/person-running.svg?component"),
  ),
  "fal-phone-arrow-down": defineAsyncComponent(
    () => import("@/assets/svg/light/phone-arrow-down.svg?component"),
  ),
  "fal-phone-arrow-up": defineAsyncComponent(
    () => import("@/assets/svg/light/phone-arrow-up.svg?component"),
  ),
  "fal-phone-hang-up": defineAsyncComponent(
    () => import("@/assets/svg/light/phone-hang-up.svg?component"),
  ),
  "fal-phone-missed": defineAsyncComponent(
    () => import("@/assets/svg/light/phone-missed.svg?component"),
  ),
  "fal-phone": defineAsyncComponent(
    () => import("@/assets/svg/light/phone.svg?component"),
  ),
  "fal-photo-video": defineAsyncComponent(
    () => import("@/assets/svg/light/photo-video.svg?component"),
  ),
  "fal-play": defineAsyncComponent(
    () => import("@/assets/svg/light/play.svg?component"),
  ),
  "fal-plus": defineAsyncComponent(
    () => import("@/assets/svg/light/plus.svg?component"),
  ),
  "fal-power-off": defineAsyncComponent(
    () => import("@/assets/svg/light/power-off.svg?component"),
  ),
  "fal-printer": defineAsyncComponent(
    () => import("@/assets/svg/light/printer.svg?component"),
  ),
  "fal-rabbit-running": defineAsyncComponent(
    () => import("@/assets/svg/light/rabbit-running.svg?component"),
  ),
  "fal-rectangle-list": defineAsyncComponent(
    () => import("@/assets/svg/light/rectangle-list.svg?component"),
  ),
  "fal-repeat": defineAsyncComponent(
    () => import("@/assets/svg/light/repeat.svg?component"),
  ),
  "fal-right-from-bracket": defineAsyncComponent(
    () => import("@/assets/svg/light/right-from-bracket.svg?component"),
  ),
  "fal-rotate-left": defineAsyncComponent(
    () => import("@/assets/svg/light/rotate-left.svg?component"),
  ),
  "fal-rotate-right": defineAsyncComponent(
    () => import("@/assets/svg/light/rotate-right.svg?component"),
  ),
  "fal-rotate": defineAsyncComponent(
    () => import("@/assets/svg/light/rotate.svg?component"),
  ),
  "fal-share-nodes": defineAsyncComponent(
    () => import("@/assets/svg/light/share-nodes.svg?component"),
  ),
  "fal-shield-check": defineAsyncComponent(
    () => import("@/assets/svg/light/shield-check.svg?component"),
  ),
  "fal-shield-halved": defineAsyncComponent(
    () => import("@/assets/svg/light/shield-halved.svg?component"),
  ),
  "fal-shuffle": defineAsyncComponent(
    () => import("@/assets/svg/light/shuffle.svg?component"),
  ),
  "fal-sign-out": defineAsyncComponent(
    () => import("@/assets/svg/light/sign-out.svg?component"),
  ),
  "fal-siren-on": defineAsyncComponent(
    () => import("@/assets/svg/light/siren-on.svg?component"),
  ),
  "fal-sliders": defineAsyncComponent(
    () => import("@/assets/svg/light/sliders.svg?component"),
  ),
  "fal-square-question": defineAsyncComponent(
    () => import("@/assets/svg/light/square-question.svg?component"),
  ),
  "fal-stethoscope": defineAsyncComponent(
    () => import("@/assets/svg/light/stethoscope.svg?component"),
  ),
  "fal-stop": defineAsyncComponent(
    () => import("@/assets/svg/light/stop.svg?component"),
  ),
  "fal-street-view": defineAsyncComponent(
    () => import("@/assets/svg/light/street-view.svg?component"),
  ),
  "fal-sun-bright": defineAsyncComponent(
    () => import("@/assets/svg/light/sun-bright.svg?component"),
  ),
  "fal-sun": defineAsyncComponent(
    () => import("@/assets/svg/light/sun.svg?component"),
  ),
  "fal-sunrise": defineAsyncComponent(
    () => import("@/assets/svg/light/sunrise.svg?component"),
  ),
  "fal-sunset": defineAsyncComponent(
    () => import("@/assets/svg/light/sunset.svg?component"),
  ),
  "fal-table-cells": defineAsyncComponent(
    () => import("@/assets/svg/light/table-cells.svg?component"),
  ),
  "fal-table-list": defineAsyncComponent(
    () => import("@/assets/svg/light/table-list.svg?component"),
  ),
  "fal-tablet": defineAsyncComponent(
    () => import("@/assets/svg/light/tablet.svg?component"),
  ),
  "fal-tag": defineAsyncComponent(
    () => import("@/assets/svg/light/tag.svg?component"),
  ),
  "fal-thumbs-down": defineAsyncComponent(
    () => import("@/assets/svg/light/thumbs-down.svg?component"),
  ),
  "fal-thumbs-up": defineAsyncComponent(
    () => import("@/assets/svg/light/thumbs-up.svg?component"),
  ),
  "fal-timeline": defineAsyncComponent(
    () => import("@/assets/svg/light/timeline.svg?component"),
  ),
  "fal-trash-can": defineAsyncComponent(
    () => import("@/assets/svg/light/trash-can.svg?component"),
  ),
  "fal-triangle-exclamation": defineAsyncComponent(
    () => import("@/assets/svg/light/triangle-exclamation.svg?component"),
  ),
  "fal-turtle": defineAsyncComponent(
    () => import("@/assets/svg/light/turtle.svg?component"),
  ),
  "fal-universal-access": defineAsyncComponent(
    () => import("@/assets/svg/light/universal-access.svg?component"),
  ),
  "fal-upload": defineAsyncComponent(
    () => import("@/assets/svg/light/upload.svg?component"),
  ),
  "fal-user-check": defineAsyncComponent(
    () => import("@/assets/svg/light/user-check.svg?component"),
  ),
  "fal-user-gear": defineAsyncComponent(
    () => import("@/assets/svg/light/user-gear.svg?component"),
  ),
  "fal-user-group": defineAsyncComponent(
    () => import("@/assets/svg/light/user-group.svg?component"),
  ),
  "fal-user-plus": defineAsyncComponent(
    () => import("@/assets/svg/light/user-plus.svg?component"),
  ),
  "fal-user-slash": defineAsyncComponent(
    () => import("@/assets/svg/light/user-slash.svg?component"),
  ),
  "fal-user": defineAsyncComponent(
    () => import("@/assets/svg/light/user.svg?component"),
  ),
  "fal-users": defineAsyncComponent(
    () => import("@/assets/svg/light/users.svg?component"),
  ),
  "fal-utensils": defineAsyncComponent(
    () => import("@/assets/svg/light/utensils.svg?component"),
  ),
  "fal-video-slash": defineAsyncComponent(
    () => import("@/assets/svg/light/video-slash.svg?component"),
  ),
  "fal-video": defineAsyncComponent(
    () => import("@/assets/svg/light/video.svg?component"),
  ),
  "fal-volume": defineAsyncComponent(
    () => import("@/assets/svg/light/volume.svg?component"),
  ),
  "fal-waveform-lines": defineAsyncComponent(
    () => import("@/assets/svg/light/waveform-lines.svg?component"),
  ),
  "fal-wheelchair": defineAsyncComponent(
    () => import("@/assets/svg/light/wheelchair.svg?component"),
  ),
  "fal-xmark": defineAsyncComponent(
    () => import("@/assets/svg/light/xmark.svg?component"),
  ),

  // far
  "far-alarm-clock": defineAsyncComponent(
    () => import("@/assets/svg/regular/alarm-clock.svg?component"),
  ),
  "far-archive": defineAsyncComponent(
    () => import("@/assets/svg/regular/archive.svg?component"),
  ),
  "far-arrow-left": defineAsyncComponent(
    () => import("@/assets/svg/regular/arrow-left.svg?component"),
  ),
  "far-arrow-right": defineAsyncComponent(
    () => import("@/assets/svg/regular/arrow-right.svg?component"),
  ),
  "far-arrow-up-right-from-square": defineAsyncComponent(
    () =>
      import("@/assets/svg/regular/arrow-up-right-from-square.svg?component"),
  ),
  "far-arrow-up": defineAsyncComponent(
    () => import("@/assets/svg/regular/arrow-up.svg?component"),
  ),
  "far-arrows-from-line": defineAsyncComponent(
    () => import("@/assets/svg/regular/arrows-from-line.svg?component"),
  ),
  "far-arrows-left-right": defineAsyncComponent(
    () => import("@/assets/svg/regular/arrows-left-right.svg?component"),
  ),
  "far-arrows-maximize": defineAsyncComponent(
    () => import("@/assets/svg/regular/arrows-maximize.svg?component"),
  ),
  "far-arrows-up-down-left-right": defineAsyncComponent(
    () =>
      import("@/assets/svg/regular/arrows-up-down-left-right.svg?component"),
  ),
  "far-arrows-up-down": defineAsyncComponent(
    () => import("@/assets/svg/regular/arrows-up-down.svg?component"),
  ),
  "far-ban": defineAsyncComponent(
    () => import("@/assets/svg/regular/ban.svg?component"),
  ),
  "far-bars-filter": defineAsyncComponent(
    () => import("@/assets/svg/regular/bars-filter.svg?component"),
  ),
  "far-bars": defineAsyncComponent(
    () => import("@/assets/svg/regular/bars.svg?component"),
  ),
  "far-bell-on": defineAsyncComponent(
    () => import("@/assets/svg/regular/bell-on.svg?component"),
  ),
  "far-bell": defineAsyncComponent(
    () => import("@/assets/svg/regular/bell.svg?component"),
  ),
  "far-books": defineAsyncComponent(
    () => import("@/assets/svg/regular/books.svg?component"),
  ),
  "far-bowl-hot": defineAsyncComponent(
    () => import("@/assets/svg/regular/bowl-hot.svg?component"),
  ),
  "far-building": defineAsyncComponent(
    () => import("@/assets/svg/regular/building.svg?component"),
  ),
  "far-bus": defineAsyncComponent(
    () => import("@/assets/svg/regular/bus.svg?component"),
  ),
  "far-cake-candles": defineAsyncComponent(
    () => import("@/assets/svg/regular/cake-candles.svg?component"),
  ),
  "far-calendar-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/calendar-check.svg?component"),
  ),
  "far-calendar-clock": defineAsyncComponent(
    () => import("@/assets/svg/regular/calendar-clock.svg?component"),
  ),
  "far-calendar-days": defineAsyncComponent(
    () => import("@/assets/svg/regular/calendar-days.svg?component"),
  ),
  "far-calendar-plus": defineAsyncComponent(
    () => import("@/assets/svg/regular/calendar-plus.svg?component"),
  ),
  "far-calendar-star": defineAsyncComponent(
    () => import("@/assets/svg/regular/calendar-star.svg?component"),
  ),
  "far-calendar-xmark": defineAsyncComponent(
    () => import("@/assets/svg/regular/calendar-xmark.svg?component"),
  ),
  "far-calendar": defineAsyncComponent(
    () => import("@/assets/svg/regular/calendar.svg?component"),
  ),
  "far-camera": defineAsyncComponent(
    () => import("@/assets/svg/regular/camera.svg?component"),
  ),
  "far-cards": defineAsyncComponent(
    () => import("@/assets/svg/regular/cards.svg?component"),
  ),
  "far-check-square": defineAsyncComponent(
    () => import("@/assets/svg/regular/check-square.svg?component"),
  ),
  "far-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/check.svg?component"),
  ),
  "far-chevron-down": defineAsyncComponent(
    () => import("@/assets/svg/regular/chevron-down.svg?component"),
  ),
  "far-chevron-left": defineAsyncComponent(
    () => import("@/assets/svg/regular/chevron-left.svg?component"),
  ),
  "far-chevron-right": defineAsyncComponent(
    () => import("@/assets/svg/regular/chevron-right.svg?component"),
  ),
  "far-chevron-up": defineAsyncComponent(
    () => import("@/assets/svg/regular/chevron-up.svg?component"),
  ),
  "far-circle-check-left": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-check-left.svg?component"),
  ),
  "far-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-check.svg?component"),
  ),
  "far-circle-dot": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-dot.svg?component"),
  ),
  "far-circle-exclamation": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-exclamation.svg?component"),
  ),
  "far-circle-minus": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-minus.svg?component"),
  ),
  "far-circle-play": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-play.svg?component"),
  ),
  "far-circle-plus": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-plus.svg?component"),
  ),
  "far-circle-question": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-question.svg?component"),
  ),
  "far-circle-stop": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-stop.svg?component"),
  ),
  "far-circle-user-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-user-circle-check.svg?component"),
  ),
  "far-circle-x": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle-x.svg?component"),
  ),
  "far-circle": defineAsyncComponent(
    () => import("@/assets/svg/regular/circle.svg?component"),
  ),
  "far-clapperboard": defineAsyncComponent(
    () => import("@/assets/svg/regular/clapperboard.svg?component"),
  ),
  "far-clipboard-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/clipboard-check.svg?component"),
  ),
  "far-clipboard-user": defineAsyncComponent(
    () => import("@/assets/svg/regular/clipboard-user.svg?component"),
  ),
  "far-clipboard": defineAsyncComponent(
    () => import("@/assets/svg/regular/clipboard.svg?component"),
  ),
  "far-clock-rotate-left": defineAsyncComponent(
    () => import("@/assets/svg/regular/clock-rotate-left.svg?component"),
  ),
  "far-clock": defineAsyncComponent(
    () => import("@/assets/svg/regular/clock.svg?component"),
  ),
  "far-copy": defineAsyncComponent(
    () => import("@/assets/svg/regular/copy.svg?component"),
  ),
  "far-crop": defineAsyncComponent(
    () => import("@/assets/svg/regular/crop.svg?component"),
  ),
  "far-delete-left": defineAsyncComponent(
    () => import("@/assets/svg/regular/delete-left.svg?component"),
  ),
  "far-diamond-turn-right": defineAsyncComponent(
    () => import("@/assets/svg/regular/diamond-turn-right.svg?component"),
  ),
  "far-dot": defineAsyncComponent(
    () => import("@/assets/svg/regular/dot.svg?component"),
  ),
  "far-download": defineAsyncComponent(
    () => import("@/assets/svg/regular/download.svg?component"),
  ),
  "far-elipsis-vertical": defineAsyncComponent(
    () => import("@/assets/svg/regular/elipsis-vertical.svg?component"),
  ),
  "far-elipsis": defineAsyncComponent(
    () => import("@/assets/svg/regular/elipsis.svg?component"),
  ),
  "far-envelope-open-text": defineAsyncComponent(
    () => import("@/assets/svg/regular/envelope-open-text.svg?component"),
  ),
  "far-eye-low-vision": defineAsyncComponent(
    () => import("@/assets/svg/regular/eye-low-vision.svg?component"),
  ),
  "far-eye-slash": defineAsyncComponent(
    () => import("@/assets/svg/regular/eye-slash.svg?component"),
  ),
  "far-eye": defineAsyncComponent(
    () => import("@/assets/svg/regular/eye.svg?component"),
  ),
  "far-face-smile-plus": defineAsyncComponent(
    () => import("@/assets/svg/regular/face-smile-plus.svg?component"),
  ),
  "far-face-smile": defineAsyncComponent(
    () => import("@/assets/svg/regular/face-smile.svg?component"),
  ),
  "far-face-viewfinder": defineAsyncComponent(
    () => import("@/assets/svg/regular/face-viewfinder.svg?component"),
  ),
  "far-family-pants": defineAsyncComponent(
    () => import("@/assets/svg/regular/family-pants.svg?component"),
  ),
  "far-file-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/file-circle-check.svg?component"),
  ),
  "far-file-lines": defineAsyncComponent(
    () => import("@/assets/svg/regular/file-lines.svg?component"),
  ),
  "far-file-pdf": defineAsyncComponent(
    () => import("@/assets/svg/regular/file-pdf.svg?component"),
  ),
  "far-file-signature": defineAsyncComponent(
    () => import("@/assets/svg/regular/file-signature.svg?component"),
  ),
  "far-film": defineAsyncComponent(
    () => import("@/assets/svg/regular/film.svg?component"),
  ),
  "far-filters": defineAsyncComponent(
    () => import("@/assets/svg/regular/filters.svg?component"),
  ),
  "far-fingerprint": defineAsyncComponent(
    () => import("@/assets/svg/regular/fingerprint.svg?component"),
  ),
  "far-floppy-disk": defineAsyncComponent(
    () => import("@/assets/svg/regular/floppy-disk.svg?component"),
  ),
  "far-fork-knife": defineAsyncComponent(
    () => import("@/assets/svg/regular/fork-knife.svg?component"),
  ),
  "far-gear": defineAsyncComponent(
    () => import("@/assets/svg/regular/gear.svg?component"),
  ),
  "far-globe": defineAsyncComponent(
    () => import("@/assets/svg/regular/globe.svg?component"),
  ),
  "far-grid-2": defineAsyncComponent(
    () => import("@/assets/svg/regular/grid-2.svg?component"),
  ),
  "far-grid": defineAsyncComponent(
    () => import("@/assets/svg/regular/grid.svg?component"),
  ),
  "far-grip-lines": defineAsyncComponent(
    () => import("@/assets/svg/regular/grip-lines.svg?component"),
  ),
  "far-hand-heart": defineAsyncComponent(
    () => import("@/assets/svg/regular/hand-heart.svg?component"),
  ),
  "far-hands-clapping": defineAsyncComponent(
    () => import("@/assets/svg/regular/hands-clapping.svg?component"),
  ),
  "far-handsheart": defineAsyncComponent(
    () => import("@/assets/svg/regular/handsheart.svg?component"),
  ),
  "far-headset": defineAsyncComponent(
    () => import("@/assets/svg/regular/headset.svg?component"),
  ),
  "far-heart": defineAsyncComponent(
    () => import("@/assets/svg/regular/heart.svg?component"),
  ),
  "far-hourglass-end": defineAsyncComponent(
    () => import("@/assets/svg/regular/hourglass-end.svg?component"),
  ),
  "far-hourglass": defineAsyncComponent(
    () => import("@/assets/svg/regular/hourglass.svg?component"),
  ),
  "far-house-user": defineAsyncComponent(
    () => import("@/assets/svg/regular/house-user.svg?component"),
  ),
  "far-house": defineAsyncComponent(
    () => import("@/assets/svg/regular/house.svg?component"),
  ),
  "far-id-card": defineAsyncComponent(
    () => import("@/assets/svg/regular/id-card.svg?component"),
  ),
  "far-image": defineAsyncComponent(
    () => import("@/assets/svg/regular/image.svg?component"),
  ),
  "far-info-circle": defineAsyncComponent(
    () => import("@/assets/svg/regular/info-circle.svg?component"),
  ),
  "far-key": defineAsyncComponent(
    () => import("@/assets/svg/regular/key.svg?component"),
  ),
  "far-layer-group": defineAsyncComponent(
    () => import("@/assets/svg/regular/layer-group.svg?component"),
  ),
  "far-lightbulb": defineAsyncComponent(
    () => import("@/assets/svg/regular/lightbulb.svg?component"),
  ),
  "far-list-checked": defineAsyncComponent(
    () => import("@/assets/svg/regular/list-checked.svg?component"),
  ),
  "far-list": defineAsyncComponent(
    () => import("@/assets/svg/regular/list.svg?component"),
  ),
  "far-loader": defineAsyncComponent(
    () => import("@/assets/svg/regular/loader.svg?component"),
  ),
  "far-location-dot": defineAsyncComponent(
    () => import("@/assets/svg/regular/location-dot.svg?component"),
  ),
  "far-lock-keyhole": defineAsyncComponent(
    () => import("@/assets/svg/regular/lock-keyhole.svg?component"),
  ),
  "far-lock-open": defineAsyncComponent(
    () => import("@/assets/svg/regular/lock-open.svg?component"),
  ),
  "far-lock": defineAsyncComponent(
    () => import("@/assets/svg/regular/lock.svg?component"),
  ),
  "far-magnifying-glass-minus": defineAsyncComponent(
    () => import("@/assets/svg/regular/magnifying-glass-minus.svg?component"),
  ),
  "far-magnifying-glass-plus": defineAsyncComponent(
    () => import("@/assets/svg/regular/magnifying-glass-plus.svg?component"),
  ),
  "far-magnifying-glass": defineAsyncComponent(
    () => import("@/assets/svg/regular/magnifying-glass.svg?component"),
  ),
  "far-medal": defineAsyncComponent(
    () => import("@/assets/svg/regular/medal.svg?component"),
  ),
  "far-megaphone": defineAsyncComponent(
    () => import("@/assets/svg/regular/megaphone.svg?component"),
  ),
  "far-message-dots": defineAsyncComponent(
    () => import("@/assets/svg/regular/message-dots.svg?component"),
  ),
  "far-messages-lines": defineAsyncComponent(
    () => import("@/assets/svg/regular/messages-lines.svg?component"),
  ),
  "far-messages": defineAsyncComponent(
    () => import("@/assets/svg/regular/messages.svg?component"),
  ),
  "far-microphone-slash-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/microphone-slash-check.svg?component"),
  ),
  "far-microphone": defineAsyncComponent(
    () => import("@/assets/svg/regular/microphone.svg?component"),
  ),
  "far-minus": defineAsyncComponent(
    () => import("@/assets/svg/regular/minus.svg?component"),
  ),
  "far-mobile-button": defineAsyncComponent(
    () => import("@/assets/svg/regular/mobile-button.svg?component"),
  ),
  "far-mobile-notch": defineAsyncComponent(
    () => import("@/assets/svg/regular/mobile-notch.svg?component"),
  ),
  "far-money-bill": defineAsyncComponent(
    () => import("@/assets/svg/regular/money-bill.svg?component"),
  ),
  "far-moon-stars": defineAsyncComponent(
    () => import("@/assets/svg/regular/moon-stars.svg?component"),
  ),
  "far-moon": defineAsyncComponent(
    () => import("@/assets/svg/regular/moon.svg?component"),
  ),
  "far-paper-plane": defineAsyncComponent(
    () => import("@/assets/svg/regular/paper-plane.svg?component"),
  ),
  "far-paperclip": defineAsyncComponent(
    () => import("@/assets/svg/regular/paperclip.svg?component"),
  ),
  "far-pause": defineAsyncComponent(
    () => import("@/assets/svg/regular/pause.svg?component"),
  ),
  "far-pen-to-square": defineAsyncComponent(
    () => import("@/assets/svg/regular/pen-to-square.svg?component"),
  ),
  "far-person-running": defineAsyncComponent(
    () => import("@/assets/svg/regular/person-running.svg?component"),
  ),
  "far-phone-arrow-down": defineAsyncComponent(
    () => import("@/assets/svg/regular/phone-arrow-down.svg?component"),
  ),
  "far-phone-arrow-up": defineAsyncComponent(
    () => import("@/assets/svg/regular/phone-arrow-up.svg?component"),
  ),
  "far-phone-hang-up": defineAsyncComponent(
    () => import("@/assets/svg/regular/phone-hang-up.svg?component"),
  ),
  "far-phone-missed": defineAsyncComponent(
    () => import("@/assets/svg/regular/phone-missed.svg?component"),
  ),
  "far-phone": defineAsyncComponent(
    () => import("@/assets/svg/regular/phone.svg?component"),
  ),
  "far-photo-video": defineAsyncComponent(
    () => import("@/assets/svg/regular/photo-video.svg?component"),
  ),
  "far-play": defineAsyncComponent(
    () => import("@/assets/svg/regular/play.svg?component"),
  ),
  "far-plus": defineAsyncComponent(
    () => import("@/assets/svg/regular/plus.svg?component"),
  ),
  "far-power-off": defineAsyncComponent(
    () => import("@/assets/svg/regular/power-off.svg?component"),
  ),
  "far-printer": defineAsyncComponent(
    () => import("@/assets/svg/regular/printer.svg?component"),
  ),
  "far-rabbit-running": defineAsyncComponent(
    () => import("@/assets/svg/regular/rabbit-running.svg?component"),
  ),
  "far-rectangle-list": defineAsyncComponent(
    () => import("@/assets/svg/regular/rectangle-list.svg?component"),
  ),
  "far-repeat": defineAsyncComponent(
    () => import("@/assets/svg/regular/repeat.svg?component"),
  ),
  "far-right-from-bracket": defineAsyncComponent(
    () => import("@/assets/svg/regular/right-from-bracket.svg?component"),
  ),
  "far-rocket": defineAsyncComponent(
    () => import("@/assets/svg/regular/rocket.svg?component"),
  ),
  "far-rotate-left": defineAsyncComponent(
    () => import("@/assets/svg/regular/rotate-left.svg?component"),
  ),
  "far-rotate-right": defineAsyncComponent(
    () => import("@/assets/svg/regular/rotate-right.svg?component"),
  ),
  "far-rotate": defineAsyncComponent(
    () => import("@/assets/svg/regular/rotate.svg?component"),
  ),
  "far-share-nodes": defineAsyncComponent(
    () => import("@/assets/svg/regular/share-nodes.svg?component"),
  ),
  "far-shield-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/shield-check.svg?component"),
  ),
  "far-shield-halved": defineAsyncComponent(
    () => import("@/assets/svg/regular/shield-halved.svg?component"),
  ),
  "far-shuffle": defineAsyncComponent(
    () => import("@/assets/svg/regular/shuffle.svg?component"),
  ),
  "far-sign-out": defineAsyncComponent(
    () => import("@/assets/svg/regular/sign-out.svg?component"),
  ),
  "far-siren-on": defineAsyncComponent(
    () => import("@/assets/svg/regular/siren-on.svg?component"),
  ),
  "far-sliders": defineAsyncComponent(
    () => import("@/assets/svg/regular/sliders.svg?component"),
  ),
  "far-square-question": defineAsyncComponent(
    () => import("@/assets/svg/regular/square-question.svg?component"),
  ),
  "far-stethoscope": defineAsyncComponent(
    () => import("@/assets/svg/regular/stethoscope.svg?component"),
  ),
  "far-stop": defineAsyncComponent(
    () => import("@/assets/svg/regular/stop.svg?component"),
  ),
  "far-street-view": defineAsyncComponent(
    () => import("@/assets/svg/regular/street-view.svg?component"),
  ),
  "far-sun-bright": defineAsyncComponent(
    () => import("@/assets/svg/regular/sun-bright.svg?component"),
  ),
  "far-sun": defineAsyncComponent(
    () => import("@/assets/svg/regular/sun.svg?component"),
  ),
  "far-sunrise": defineAsyncComponent(
    () => import("@/assets/svg/regular/sunrise.svg?component"),
  ),
  "far-sunset": defineAsyncComponent(
    () => import("@/assets/svg/regular/sunset.svg?component"),
  ),
  "far-table-cells": defineAsyncComponent(
    () => import("@/assets/svg/regular/table-cells.svg?component"),
  ),
  "far-table-list": defineAsyncComponent(
    () => import("@/assets/svg/regular/table-list.svg?component"),
  ),
  "far-tablet": defineAsyncComponent(
    () => import("@/assets/svg/regular/tablet.svg?component"),
  ),
  "far-tag": defineAsyncComponent(
    () => import("@/assets/svg/regular/tag.svg?component"),
  ),
  "far-thumbs-down": defineAsyncComponent(
    () => import("@/assets/svg/regular/thumbs-down.svg?component"),
  ),
  "far-thumbs-up": defineAsyncComponent(
    () => import("@/assets/svg/regular/thumbs-up.svg?component"),
  ),
  "far-timeline": defineAsyncComponent(
    () => import("@/assets/svg/regular/timeline.svg?component"),
  ),
  "far-trash-can": defineAsyncComponent(
    () => import("@/assets/svg/regular/trash-can.svg?component"),
  ),
  "far-triangle-exclamation": defineAsyncComponent(
    () => import("@/assets/svg/regular/triangle-exclamation.svg?component"),
  ),
  "far-turtle": defineAsyncComponent(
    () => import("@/assets/svg/regular/turtle.svg?component"),
  ),
  "far-universal-access": defineAsyncComponent(
    () => import("@/assets/svg/regular/universal-access.svg?component"),
  ),
  "far-upload": defineAsyncComponent(
    () => import("@/assets/svg/regular/upload.svg?component"),
  ),
  "far-user-check": defineAsyncComponent(
    () => import("@/assets/svg/regular/user-check.svg?component"),
  ),
  "far-user-gear": defineAsyncComponent(
    () => import("@/assets/svg/regular/user-gear.svg?component"),
  ),
  "far-user-group": defineAsyncComponent(
    () => import("@/assets/svg/regular/user-group.svg?component"),
  ),
  "far-user-plus": defineAsyncComponent(
    () => import("@/assets/svg/regular/user-plus.svg?component"),
  ),
  "far-user-slash": defineAsyncComponent(
    () => import("@/assets/svg/regular/user-slash.svg?component"),
  ),
  "far-user": defineAsyncComponent(
    () => import("@/assets/svg/regular/user.svg?component"),
  ),
  "far-users": defineAsyncComponent(
    () => import("@/assets/svg/regular/users.svg?component"),
  ),
  "far-utensils": defineAsyncComponent(
    () => import("@/assets/svg/regular/utensils.svg?component"),
  ),
  "far-video-slash": defineAsyncComponent(
    () => import("@/assets/svg/regular/video-slash.svg?component"),
  ),
  "far-video": defineAsyncComponent(
    () => import("@/assets/svg/regular/video.svg?component"),
  ),
  "far-volume": defineAsyncComponent(
    () => import("@/assets/svg/regular/volume.svg?component"),
  ),
  "far-waveform-lines": defineAsyncComponent(
    () => import("@/assets/svg/regular/waveform-lines.svg?component"),
  ),
  "far-wheelchair": defineAsyncComponent(
    () => import("@/assets/svg/regular/wheelchair.svg?component"),
  ),
  "far-xmark": defineAsyncComponent(
    () => import("@/assets/svg/regular/xmark.svg?component"),
  ),

  // fas
  "fas-alarm-clock": defineAsyncComponent(
    () => import("@/assets/svg/solid/alarm-clock.svg?component"),
  ),
  "fas-archive": defineAsyncComponent(
    () => import("@/assets/svg/solid/archive.svg?component"),
  ),
  "fas-arrow-left": defineAsyncComponent(
    () => import("@/assets/svg/solid/arrow-left.svg?component"),
  ),
  "fas-arrow-right": defineAsyncComponent(
    () => import("@/assets/svg/solid/arrow-right.svg?component"),
  ),
  "fas-arrow-up-right-from-square": defineAsyncComponent(
    () => import("@/assets/svg/solid/arrow-up-right-from-square.svg?component"),
  ),
  "fas-arrow-up": defineAsyncComponent(
    () => import("@/assets/svg/solid/arrow-up.svg?component"),
  ),
  "fas-arrows-from-line": defineAsyncComponent(
    () => import("@/assets/svg/solid/arrows-from-line.svg?component"),
  ),
  "fas-arrows-up-down-left-right": defineAsyncComponent(
    () => import("@/assets/svg/solid/arrows-up-down-left-right.svg?component"),
  ),
  "fas-ban": defineAsyncComponent(
    () => import("@/assets/svg/solid/ban.svg?component"),
  ),
  "fas-bars-filter": defineAsyncComponent(
    () => import("@/assets/svg/solid/bars-filter.svg?component"),
  ),
  "fas-bars": defineAsyncComponent(
    () => import("@/assets/svg/solid/bars.svg?component"),
  ),
  "fas-bell-on": defineAsyncComponent(
    () => import("@/assets/svg/solid/bell-on.svg?component"),
  ),
  "fas-bell": defineAsyncComponent(
    () => import("@/assets/svg/solid/bell.svg?component"),
  ),
  "fas-books": defineAsyncComponent(
    () => import("@/assets/svg/solid/books.svg?component"),
  ),
  "fas-bowl-hot": defineAsyncComponent(
    () => import("@/assets/svg/solid/bowl-hot.svg?component"),
  ),
  "fas-building": defineAsyncComponent(
    () => import("@/assets/svg/solid/building.svg?component"),
  ),
  "fas-bus": defineAsyncComponent(
    () => import("@/assets/svg/solid/bus.svg?component"),
  ),
  "fas-cake-candles": defineAsyncComponent(
    () => import("@/assets/svg/solid/cake-candles.svg?component"),
  ),
  "fas-calendar-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/calendar-check.svg?component"),
  ),
  "fas-calendar-clock": defineAsyncComponent(
    () => import("@/assets/svg/solid/calendar-clock.svg?component"),
  ),
  "fas-calendar-days": defineAsyncComponent(
    () => import("@/assets/svg/solid/calendar-days.svg?component"),
  ),
  "fas-calendar-plus": defineAsyncComponent(
    () => import("@/assets/svg/solid/calendar-plus.svg?component"),
  ),
  "fas-calendar-star": defineAsyncComponent(
    () => import("@/assets/svg/solid/calendar-star.svg?component"),
  ),
  "fas-calendar-xmark": defineAsyncComponent(
    () => import("@/assets/svg/solid/calendar-xmark.svg?component"),
  ),
  "fas-calendar": defineAsyncComponent(
    () => import("@/assets/svg/solid/calendar.svg?component"),
  ),
  "fas-camera": defineAsyncComponent(
    () => import("@/assets/svg/solid/camera.svg?component"),
  ),
  "fas-cards": defineAsyncComponent(
    () => import("@/assets/svg/solid/cards.svg?component"),
  ),
  "fas-caret-down": defineAsyncComponent(
    () => import("@/assets/svg/solid/caret-down.svg?component"),
  ),
  "fas-caret-up": defineAsyncComponent(
    () => import("@/assets/svg/solid/caret-up.svg?component"),
  ),
  "fas-check-square": defineAsyncComponent(
    () => import("@/assets/svg/solid/check-square.svg?component"),
  ),
  "fas-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/check.svg?component"),
  ),
  "fas-chevron-down": defineAsyncComponent(
    () => import("@/assets/svg/solid/chevron-down.svg?component"),
  ),
  "fas-chevron-left": defineAsyncComponent(
    () => import("@/assets/svg/solid/chevron-left.svg?component"),
  ),
  "fas-chevron-right": defineAsyncComponent(
    () => import("@/assets/svg/solid/chevron-right.svg?component"),
  ),
  "fas-chevron-up": defineAsyncComponent(
    () => import("@/assets/svg/solid/chevron-up.svg?component"),
  ),
  "fas-circle-check-left": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-check-left.svg?component"),
  ),
  "fas-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-check.svg?component"),
  ),
  "fas-circle-dot": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-dot.svg?component"),
  ),
  "fas-circle-exclamation": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-exclamation.svg?component"),
  ),
  "fas-circle-minus": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-minus.svg?component"),
  ),
  "fas-circle-play": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-play.svg?component"),
  ),
  "fas-circle-plus": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-plus.svg?component"),
  ),
  "fas-circle-question": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-question.svg?component"),
  ),
  "fas-circle-stop": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-stop.svg?component"),
  ),
  "fas-circle-user-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-user-circle-check.svg?component"),
  ),
  "fas-circle-x": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle-x.svg?component"),
  ),
  "fas-circle": defineAsyncComponent(
    () => import("@/assets/svg/solid/circle.svg?component"),
  ),
  "fas-clapperboard": defineAsyncComponent(
    () => import("@/assets/svg/solid/clapperboard.svg?component"),
  ),
  "fas-clipboard-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/clipboard-check.svg?component"),
  ),
  "fas-clipboard-user": defineAsyncComponent(
    () => import("@/assets/svg/solid/clipboard-user.svg?component"),
  ),
  "fas-clipboard": defineAsyncComponent(
    () => import("@/assets/svg/solid/clipboard.svg?component"),
  ),
  "fas-clock-rotate-left": defineAsyncComponent(
    () => import("@/assets/svg/solid/clock-rotate-left.svg?component"),
  ),
  "fas-clock": defineAsyncComponent(
    () => import("@/assets/svg/solid/clock.svg?component"),
  ),
  "fas-copy": defineAsyncComponent(
    () => import("@/assets/svg/solid/copy.svg?component"),
  ),
  "fas-crop": defineAsyncComponent(
    () => import("@/assets/svg/solid/crop.svg?component"),
  ),
  "fas-delete-left": defineAsyncComponent(
    () => import("@/assets/svg/solid/delete-left.svg?component"),
  ),
  "fas-diamond-turn-right": defineAsyncComponent(
    () => import("@/assets/svg/solid/diamond-turn-right.svg?component"),
  ),
  "fas-dot": defineAsyncComponent(
    () => import("@/assets/svg/solid/dot.svg?component"),
  ),
  "fas-download": defineAsyncComponent(
    () => import("@/assets/svg/solid/download.svg?component"),
  ),
  "fas-elipsis-vertical": defineAsyncComponent(
    () => import("@/assets/svg/solid/elipsis-vertical.svg?component"),
  ),
  "fas-elipsis": defineAsyncComponent(
    () => import("@/assets/svg/solid/elipsis.svg?component"),
  ),
  "fas-envelope-open-text": defineAsyncComponent(
    () => import("@/assets/svg/solid/envelope-open-text.svg?component"),
  ),
  "fas-eye-low-vision": defineAsyncComponent(
    () => import("@/assets/svg/solid/eye-low-vision.svg?component"),
  ),
  "fas-eye-slash": defineAsyncComponent(
    () => import("@/assets/svg/solid/eye-slash.svg?component"),
  ),
  "fas-eye": defineAsyncComponent(
    () => import("@/assets/svg/solid/eye.svg?component"),
  ),
  "fas-face-smile-plus": defineAsyncComponent(
    () => import("@/assets/svg/solid/face-smile-plus.svg?component"),
  ),
  "fas-face-smile": defineAsyncComponent(
    () => import("@/assets/svg/solid/face-smile.svg?component"),
  ),
  "fas-face-viewfinder": defineAsyncComponent(
    () => import("@/assets/svg/solid/face-viewfinder.svg?component"),
  ),
  "fas-family-pants": defineAsyncComponent(
    () => import("@/assets/svg/solid/family-pants.svg?component"),
  ),
  "fas-fax": defineAsyncComponent(
    () => import("@/assets/svg/solid/fax.svg?component"),
  ),
  "fas-file-circle-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/file-circle-check.svg?component"),
  ),
  "fas-file-lines": defineAsyncComponent(
    () => import("@/assets/svg/solid/file-lines.svg?component"),
  ),
  "fas-file-pdf": defineAsyncComponent(
    () => import("@/assets/svg/solid/file-pdf.svg?component"),
  ),
  "fas-file-signature": defineAsyncComponent(
    () => import("@/assets/svg/solid/file-signature.svg?component"),
  ),
  "fas-film": defineAsyncComponent(
    () => import("@/assets/svg/solid/film.svg?component"),
  ),
  "fas-filters": defineAsyncComponent(
    () => import("@/assets/svg/solid/filters.svg?component"),
  ),
  "fas-fingerprint": defineAsyncComponent(
    () => import("@/assets/svg/solid/fingerprint.svg?component"),
  ),
  "fas-floppy-disk": defineAsyncComponent(
    () => import("@/assets/svg/solid/floppy-disk.svg?component"),
  ),
  "fas-fork-knife": defineAsyncComponent(
    () => import("@/assets/svg/solid/fork-knife.svg?component"),
  ),
  "fas-gear": defineAsyncComponent(
    () => import("@/assets/svg/solid/gear.svg?component"),
  ),
  "fas-globe": defineAsyncComponent(
    () => import("@/assets/svg/solid/globe.svg?component"),
  ),
  "fas-grid-2": defineAsyncComponent(
    () => import("@/assets/svg/solid/grid-2.svg?component"),
  ),
  "fas-grid": defineAsyncComponent(
    () => import("@/assets/svg/solid/grid.svg?component"),
  ),
  "fas-grip-lines": defineAsyncComponent(
    () => import("@/assets/svg/solid/grip-lines.svg?component"),
  ),
  "fas-hand-heart": defineAsyncComponent(
    () => import("@/assets/svg/solid/hand-heart.svg?component"),
  ),
  "fas-hands-clapping": defineAsyncComponent(
    () => import("@/assets/svg/solid/hands-clapping.svg?component"),
  ),
  "fas-handsheart": defineAsyncComponent(
    () => import("@/assets/svg/solid/handsheart.svg?component"),
  ),
  "fas-headset": defineAsyncComponent(
    () => import("@/assets/svg/solid/headset.svg?component"),
  ),
  "fas-heart": defineAsyncComponent(
    () => import("@/assets/svg/solid/heart.svg?component"),
  ),
  "fas-hourglass-end": defineAsyncComponent(
    () => import("@/assets/svg/solid/hourglass-end.svg?component"),
  ),
  "fas-hourglass": defineAsyncComponent(
    () => import("@/assets/svg/solid/hourglass.svg?component"),
  ),
  "fas-house-user": defineAsyncComponent(
    () => import("@/assets/svg/solid/house-user.svg?component"),
  ),
  "fas-house": defineAsyncComponent(
    () => import("@/assets/svg/solid/house.svg?component"),
  ),
  "fas-id-card": defineAsyncComponent(
    () => import("@/assets/svg/solid/id-card.svg?component"),
  ),
  "fas-image": defineAsyncComponent(
    () => import("@/assets/svg/solid/image.svg?component"),
  ),
  "fas-info-circle": defineAsyncComponent(
    () => import("@/assets/svg/solid/info-circle.svg?component"),
  ),
  "fas-key": defineAsyncComponent(
    () => import("@/assets/svg/solid/key.svg?component"),
  ),
  "fas-layer-group": defineAsyncComponent(
    () => import("@/assets/svg/solid/layer-group.svg?component"),
  ),
  "fas-lightbulb": defineAsyncComponent(
    () => import("@/assets/svg/solid/lightbulb.svg?component"),
  ),
  "fas-list-checked": defineAsyncComponent(
    () => import("@/assets/svg/solid/list-checked.svg?component"),
  ),
  "fas-list": defineAsyncComponent(
    () => import("@/assets/svg/solid/list.svg?component"),
  ),
  "fas-loader": defineAsyncComponent(
    () => import("@/assets/svg/solid/loader.svg?component"),
  ),
  "fas-location-dot": defineAsyncComponent(
    () => import("@/assets/svg/solid/location-dot.svg?component"),
  ),
  "fas-lock-keyhole": defineAsyncComponent(
    () => import("@/assets/svg/solid/lock-keyhole.svg?component"),
  ),
  "fas-lock-open": defineAsyncComponent(
    () => import("@/assets/svg/solid/lock-open.svg?component"),
  ),
  "fas-lock": defineAsyncComponent(
    () => import("@/assets/svg/solid/lock.svg?component"),
  ),
  "fas-magnifying-glass-minus": defineAsyncComponent(
    () => import("@/assets/svg/solid/magnifying-glass-minus.svg?component"),
  ),
  "fas-magnifying-glass-plus": defineAsyncComponent(
    () => import("@/assets/svg/solid/magnifying-glass-plus.svg?component"),
  ),
  "fas-magnifying-glass": defineAsyncComponent(
    () => import("@/assets/svg/solid/magnifying-glass.svg?component"),
  ),
  "fas-medal": defineAsyncComponent(
    () => import("@/assets/svg/solid/medal.svg?component"),
  ),
  "fas-megaphone": defineAsyncComponent(
    () => import("@/assets/svg/solid/megaphone.svg?component"),
  ),
  "fas-message-dots": defineAsyncComponent(
    () => import("@/assets/svg/solid/message-dots.svg?component"),
  ),
  "fas-messages-lines": defineAsyncComponent(
    () => import("@/assets/svg/solid/messages-lines.svg?component"),
  ),
  "fas-messages": defineAsyncComponent(
    () => import("@/assets/svg/solid/messages.svg?component"),
  ),
  "fas-microphone-slash-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/microphone-slash-check.svg?component"),
  ),
  "fas-microphone": defineAsyncComponent(
    () => import("@/assets/svg/solid/microphone.svg?component"),
  ),
  "fas-minus": defineAsyncComponent(
    () => import("@/assets/svg/solid/minus.svg?component"),
  ),
  "fas-mobile-button": defineAsyncComponent(
    () => import("@/assets/svg/solid/mobile-button.svg?component"),
  ),
  "fas-mobile-notch": defineAsyncComponent(
    () => import("@/assets/svg/solid/mobile-notch.svg?component"),
  ),
  "fas-money-bill": defineAsyncComponent(
    () => import("@/assets/svg/solid/money-bill.svg?component"),
  ),
  "fas-moon-stars": defineAsyncComponent(
    () => import("@/assets/svg/solid/moon-stars.svg?component"),
  ),
  "fas-moon": defineAsyncComponent(
    () => import("@/assets/svg/solid/moon.svg?component"),
  ),
  "fas-paper-plane": defineAsyncComponent(
    () => import("@/assets/svg/solid/paper-plane.svg?component"),
  ),
  "fas-paperclip": defineAsyncComponent(
    () => import("@/assets/svg/solid/paperclip.svg?component"),
  ),
  "fas-pause": defineAsyncComponent(
    () => import("@/assets/svg/solid/pause.svg?component"),
  ),
  "fas-pen-to-square": defineAsyncComponent(
    () => import("@/assets/svg/solid/pen-to-square.svg?component"),
  ),
  "fas-person-running": defineAsyncComponent(
    () => import("@/assets/svg/solid/person-running.svg?component"),
  ),
  "fas-phone-arrow-down": defineAsyncComponent(
    () => import("@/assets/svg/solid/phone-arrow-down.svg?component"),
  ),
  "fas-phone-arrow-up": defineAsyncComponent(
    () => import("@/assets/svg/solid/phone-arrow-up.svg?component"),
  ),
  "fas-phone-hang-up": defineAsyncComponent(
    () => import("@/assets/svg/solid/phone-hang-up.svg?component"),
  ),
  "fas-phone-missed": defineAsyncComponent(
    () => import("@/assets/svg/solid/phone-missed.svg?component"),
  ),
  "fas-phone": defineAsyncComponent(
    () => import("@/assets/svg/solid/phone.svg?component"),
  ),
  "fas-photo-video": defineAsyncComponent(
    () => import("@/assets/svg/solid/photo-video.svg?component"),
  ),
  "fas-play": defineAsyncComponent(
    () => import("@/assets/svg/solid/play.svg?component"),
  ),
  "fas-plus": defineAsyncComponent(
    () => import("@/assets/svg/solid/plus.svg?component"),
  ),
  "fas-power-off": defineAsyncComponent(
    () => import("@/assets/svg/solid/power-off.svg?component"),
  ),
  "fas-printer": defineAsyncComponent(
    () => import("@/assets/svg/solid/printer.svg?component"),
  ),
  "fas-rabbit-running": defineAsyncComponent(
    () => import("@/assets/svg/solid/rabbit-running.svg?component"),
  ),
  "fas-rectangle-list": defineAsyncComponent(
    () => import("@/assets/svg/solid/rectangle-list.svg?component"),
  ),
  "fas-repeat": defineAsyncComponent(
    () => import("@/assets/svg/solid/repeat.svg?component"),
  ),
  "fas-right-from-bracket": defineAsyncComponent(
    () => import("@/assets/svg/solid/right-from-bracket.svg?component"),
  ),
  "fas-rotate-left": defineAsyncComponent(
    () => import("@/assets/svg/solid/rotate-left.svg?component"),
  ),
  "fas-rotate-right": defineAsyncComponent(
    () => import("@/assets/svg/solid/rotate-right.svg?component"),
  ),
  "fas-rotate": defineAsyncComponent(
    () => import("@/assets/svg/solid/rotate.svg?component"),
  ),
  "fas-share-nodes": defineAsyncComponent(
    () => import("@/assets/svg/solid/share-nodes.svg?component"),
  ),
  "fas-shield-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/shield-check.svg?component"),
  ),
  "fas-shield-halved": defineAsyncComponent(
    () => import("@/assets/svg/solid/shield-halved.svg?component"),
  ),
  "fas-shuffle": defineAsyncComponent(
    () => import("@/assets/svg/solid/shuffle.svg?component"),
  ),
  "fas-sign-out": defineAsyncComponent(
    () => import("@/assets/svg/solid/sign-out.svg?component"),
  ),
  "fas-siren-on": defineAsyncComponent(
    () => import("@/assets/svg/solid/siren-on.svg?component"),
  ),
  "fas-sliders": defineAsyncComponent(
    () => import("@/assets/svg/solid/sliders.svg?component"),
  ),
  "fas-spinner-third": defineAsyncComponent(
    () => import("@/assets/svg/solid/spinner-third.svg?component"),
  ),
  "fas-square-question": defineAsyncComponent(
    () => import("@/assets/svg/solid/square-question.svg?component"),
  ),
  "fas-stethoscope": defineAsyncComponent(
    () => import("@/assets/svg/solid/stethoscope.svg?component"),
  ),
  "fas-stop": defineAsyncComponent(
    () => import("@/assets/svg/solid/stop.svg?component"),
  ),
  "fas-street-view": defineAsyncComponent(
    () => import("@/assets/svg/solid/street-view.svg?component"),
  ),
  "fas-sun-bright": defineAsyncComponent(
    () => import("@/assets/svg/solid/sun-bright.svg?component"),
  ),
  "fas-sun": defineAsyncComponent(
    () => import("@/assets/svg/solid/sun.svg?component"),
  ),
  "fas-sunrise": defineAsyncComponent(
    () => import("@/assets/svg/solid/sunrise.svg?component"),
  ),
  "fas-sunset": defineAsyncComponent(
    () => import("@/assets/svg/solid/sunset.svg?component"),
  ),
  "fas-table-cells": defineAsyncComponent(
    () => import("@/assets/svg/solid/table-cells.svg?component"),
  ),
  "fas-table-list": defineAsyncComponent(
    () => import("@/assets/svg/solid/table-list.svg?component"),
  ),
  "fas-tablet": defineAsyncComponent(
    () => import("@/assets/svg/solid/tablet.svg?component"),
  ),
  "fas-tag": defineAsyncComponent(
    () => import("@/assets/svg/solid/tag.svg?component"),
  ),
  "fas-thumbs-down": defineAsyncComponent(
    () => import("@/assets/svg/solid/thumbs-down.svg?component"),
  ),
  "fas-thumbs-up": defineAsyncComponent(
    () => import("@/assets/svg/solid/thumbs-up.svg?component"),
  ),
  "fas-timeline": defineAsyncComponent(
    () => import("@/assets/svg/solid/timeline.svg?component"),
  ),
  "fas-trash-can": defineAsyncComponent(
    () => import("@/assets/svg/solid/trash-can.svg?component"),
  ),
  "fas-triangle-exclamation": defineAsyncComponent(
    () => import("@/assets/svg/solid/triangle-exclamation.svg?component"),
  ),
  "fas-turtle": defineAsyncComponent(
    () => import("@/assets/svg/solid/turtle.svg?component"),
  ),
  "fas-universal-access": defineAsyncComponent(
    () => import("@/assets/svg/solid/universal-access.svg?component"),
  ),
  "fas-upload": defineAsyncComponent(
    () => import("@/assets/svg/solid/upload.svg?component"),
  ),
  "fas-user-check": defineAsyncComponent(
    () => import("@/assets/svg/solid/user-check.svg?component"),
  ),
  "fas-user-gear": defineAsyncComponent(
    () => import("@/assets/svg/solid/user-gear.svg?component"),
  ),
  "fas-user-group": defineAsyncComponent(
    () => import("@/assets/svg/solid/user-group.svg?component"),
  ),
  "fas-user-plus": defineAsyncComponent(
    () => import("@/assets/svg/solid/user-plus.svg?component"),
  ),
  "fas-user-slash": defineAsyncComponent(
    () => import("@/assets/svg/solid/user-slash.svg?component"),
  ),
  "fas-user": defineAsyncComponent(
    () => import("@/assets/svg/solid/user.svg?component"),
  ),
  "fas-users": defineAsyncComponent(
    () => import("@/assets/svg/solid/users.svg?component"),
  ),
  "fas-utensils": defineAsyncComponent(
    () => import("@/assets/svg/solid/utensils.svg?component"),
  ),
  "fas-video-slash": defineAsyncComponent(
    () => import("@/assets/svg/solid/video-slash.svg?component"),
  ),
  "fas-video": defineAsyncComponent(
    () => import("@/assets/svg/solid/video.svg?component"),
  ),
  "fas-volume": defineAsyncComponent(
    () => import("@/assets/svg/solid/volume.svg?component"),
  ),
  "fas-waveform-lines": defineAsyncComponent(
    () => import("@/assets/svg/solid/waveform-lines.svg?component"),
  ),
  "fas-wheelchair": defineAsyncComponent(
    () => import("@/assets/svg/solid/wheelchair.svg?component"),
  ),
  "fas-xmark": defineAsyncComponent(
    () => import("@/assets/svg/solid/xmark.svg?component"),
  ),
} as const;

export type SVGName = keyof typeof SVGIcons;
